import type { RawValidResponse } from '../goodstack'

import type { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export type ActivityTag = {
  id: string
  name: string
  slug: string
}

export const getActivityTags: QueryFn<[string], ActivityTag[]> = async client => {
  const res = await client.get<RawValidResponse<ActivityTag[]>>(`v1/giving/activity-tags`, {
    withCredentials: true
  })

  return res.data.data
}
